import type { AuditAction, AuditEntityType } from '@/types/audit';

export const AUDIT_ACTION_LABELS: Record<AuditAction, string> = {
  create: 'Creación',
  update: 'Actualización',
  delete: 'Eliminación',
  soft_delete: 'Baja lógica',
  restore: 'Restauración',
  status_change: 'Cambio de estado',
  role_change: 'Cambio de rol',
  login: 'Inicio de sesión',
  logout: 'Cierre de sesión',
  permission_denied: 'Acceso denegado',
};

export const AUDIT_ENTITY_LABELS: Record<AuditEntityType, string> = {
  user: 'Usuario',
  category: 'Categoría',
  subcategory: 'Subcategoría',
  customFieldDefinition: 'Campo personalizado',
  inventoryItem: 'Artículo',
  reservation: 'Reserva',
  client: 'Cliente',
  commercialOperation: 'Operación comercial',
  logisticsOrder: 'Orden logística',
  logisticsProvider: 'Proveedor logística',
  maintenanceTask: 'Mantenimiento',
  inventoryMovement: 'Movimiento inventario',
  inventoryLocation: 'Ubicación inventario',
  invoice: 'Factura',
  system: 'Sistema',
};

export function summarizeAuditChange(log: {
  action: AuditAction;
  changedFields?: string[];
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
}): string {
  if (log.action === 'create') return 'Registro creado.';
  if (log.action === 'permission_denied') return 'Intento de acceso sin permiso.';
  if (log.action === 'login' || log.action === 'logout') {
    return AUDIT_ACTION_LABELS[log.action];
  }
  if (log.action === 'role_change') {
    const from = log.before?.role;
    const to = log.after?.role;
    if (from !== undefined && to !== undefined) {
      return `Rol: ${String(from)} → ${String(to)}`;
    }
  }
  if (log.action === 'status_change') {
    const from = log.before?.status;
    const to = log.after?.status;
    if (from !== undefined && to !== undefined) {
      return `Estado: ${String(from)} → ${String(to)}`;
    }
  }
  if (log.changedFields?.length) {
    return `Campos: ${log.changedFields.join(', ')}`;
  }
  return AUDIT_ACTION_LABELS[log.action];
}
